const watchForURLChange = (onURLChange) => {
    let oldHref = document.location.href;
    const mObserver = new MutationObserver(() => {
        if (oldHref !== document.location.href) {
            oldHref = document.location.href;
            onURLChange && onURLChange();
        }
    });
    mObserver.observe(document.body, { childList: true, subtree: true });

    // if (!window.navigation) {
    //     return;
    // }
    // window.navigation.addEventListener('navigate', () => {
    //     onURLChange && onURLChange();
    // });
};

export { watchForURLChange };
